/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="65.46"
        height="48.3"
        viewBox="0 0 65.46 48.3"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <g
          fill="none"
          strokeWidth="1.5"
          strokeLinejoin="round"
          strokeLinecap="round">
          <path
            stroke="#ffb81c"
            d="M11.53 12.35a141 141 0 0 1 32.4 35.2M8.23 19.75l11.2-.7M13.43 29.55l14.1-2.8M22.63 10.25l-3.2 8.8M29.63 17.75l-2.1 9"
            className="icon-stroke icon-accent"/>
          <path
            stroke="#0e497b"
            d="M40.63 19.75a19 19 0 0 0-4.2-7.6C26.53 1.35.83.75.83.75s-1.5 25.6 8.5 36.4a18.36 18.36 0 0 0 26 1.1h0a18.75 18.75 0 0 0 3.7-4.7"
            className="icon-stroke icon-base"/>
          <path
            stroke="#ffb81c"
            d="M44 47.55a93.19 93.19 0 0 1 11.4-31.1M52.03 23.15l7.7-2.8M48.83 30.45l10.2-2.1M52.03 23.15l-4.6-5M48.83 30.45l-3.9-5.3"
            className="icon-stroke icon-accent"/>
          <path
            stroke="#0e497b"
            d="M47 40.25a13.17 13.17 0 0 0 16.8-8.2h0c3.5-9.8-4.6-26.3-4.6-26.3s-16.8 7.7-20.3 17.7h0a13 13 0 0 0 8.1 16.8Z"
            className="icon-stroke icon-base"/>
        </g>
      </svg>

    );
  }
}

Icon.displayName = 'TwoLeavesIcon';

export default Icon;
